<template>
  <form>
    <form-item
      :title="$t('name')"
      vertical
    >
      <text-input
        :value="value.name"
        :placeholder="$t('action.enter.name')"
        @input="updateValue('name', $event)"
      />
    </form-item>
    <form-item
      :title="$t('segment-form.regexp')"
      vertical
    >
      <text-input
        :value="value.regex"
        :placeholder="$t('action.enter.regexp')"
        @input="updateValue('regex', $event)"
      />
    </form-item>
    <div
      v-if="!!value.id"
      :class="$style.delete"
      role="button"
      @click="$emit('delete')"
    >
      <icon
        :class="$style.icon"
        name="trash"
      />
      {{ $t('action.delete') }}
    </div>
  </form>
</template>

<script>
import AbstractForm from '@/modules/form/AbstractForm';

export default {
  name: 'SegmentForm',
  extends: AbstractForm,
  data() {
    return {};
  },
}
</script>

<style lang="scss" module>
@import '~@/ui-kit/_theme/main.scss';

.delete {
  display: flex;
  color: $danger-color;
  align-items: center;

  .icon {
    margin-right: $gap-xs;

    path {
      fill: $text-minor-color;
      transition: fill $standart-transition;
    }
  }

  &:hover {
    .icon {
      path {
        fill: $text-secondary-color;
      }
    }
  }
}
</style>
